import React from 'react';

const TarrifTypes: React.FC = () => {
  return (
    <>
      <div className='setting-table-conts' style={{ width: '100%' }}>
        <div className='setting-table-cont-sec'>
          <div className='view-history-head-frame'>
            <div className='view-history-head-frame-cell'>
              <div className='view-history-head-frame-cell-cont'>
                <div className='view-history-head-frame-cell-cont-text' style={{ fontSize: '14px', fontWeight: '600' }}>
                Tariff Type
                </div>
              </div>
            </div>
            <div className='view-history-head-frame-cell'>
              <div className='view-history-head-frame-cell-cont'>
                <div className='view-history-head-frame-cell-cont-text' style={{ fontSize: '14px', fontWeight: '600' }}>
                HTS Code
                </div>
              </div>
            </div>
            <div className='view-history-head-frame-cell'>
              <div className='view-history-head-frame-cell-cont'>
                <div className='view-history-head-frame-cell-cont-text' style={{ fontSize: '14px', fontWeight: '600' }}>
                Tariff Rate
                </div>
              </div>
            </div>
          </div>
          <div className='settings-table-frame'>
            <div className='settings-table-frame-row'>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-texts-tar'>Section 301</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-texts-tar'>960321</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-texts-tar'>15.2%</div>
              </div>
            </div>
            <div className='settings-table-frame-row' >
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-texts-tar'>Section 232</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-texts-tar'>850440</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-texts-tar'>8%</div>
              </div>
            </div>
            <div className='settings-table-frame-row' >
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-texts-tar'>Section 301 IEEPA</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-texts-tar'>210690</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-texts-tar'>12%</div>
              </div>
            </div>
            <div className='settings-table-frame-row' >
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-texts-tar'>Reciprocal</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-texts-tar'>720852</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-texts-tar'>10.5%</div>
              </div>
            </div>
            <div className='settings-table-frame-row' >
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-texts-tar'>Countervailing</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-texts-tar'>400122</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-texts-tar'>7.8%</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TarrifTypes;
